<template>
  <header class="header">
    <div class="header-content">
      <div class="logo-container">
        <img src="@/assets/header_logo.jpg" alt="Yellow Fish Logo" class="logo-image">
        <h1 class="store-name">{{ storeName }}</h1>
      </div>
      <div class="user-info" v-if="isLoggedIn">
        <div class="user-item">
          <i class="fas fa-user user-icon"></i>
          <span class="user-label">{{ userName }}</span>
        </div>
        <div class="user-item">
          <i class="fas fa-sign-out-alt user-icon"></i>
          <span class="logout-label" @click="logout">ログアウト</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    userName() {
      return this.$store.getters['auth/currentUser']?.accountName || '';
    },
    storeName() {
      return this.$store.getters['auth/currentUser']?.storeName || '';
    }
  },
  methods: {
    logout() {
      // ログアウト処理
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.header {
  background-color: #ffed27;
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 60px; /* ヘッダーの高さを60pxに設定 */
  display: flex;
  align-items: center;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 40px;
  margin-right: 20px; /* ロゴと店舗名の間隔を20pxに設定 */
}

.store-name {
  margin: 0;
  font-size: 1.25rem;
  color: #4b4847;
  font-weight: bold;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px; /* 要素間の間隔を20pxに設定 */
  margin-right: 10px; /* ログアウトの右マージンを10pxに設定 */
}

.user-item {
  display: flex;
  align-items: center;
}

.user-item:first-child {
  white-space: nowrap;
  width: auto;
  flex-shrink: 0;
}

.user-item:last-child {
  width: 140px;
}

.user-icon {
  font-size: 18px;
  margin-right: 5px;
  color: #4b4847;
}

.user-label {
  color: #4b4847;
  font-weight: bold;
  font-size: 18px;
}

.logout-label {
  cursor: pointer;
  color: #4b4847;
  font-weight: bold;
  font-size: 18px;
}
</style>
